import React from "react";
import styled from "styled-components";
import * as variable from "../../utilities/Variables";
import { capitalizeFirstLetter } from "../../utilities/Helpers";
import WhiteSpinner from "../../assets/white-spinner.svg";
import RightArrow from "../../assets/right-arrow.png"

const Container = styled.button`
  background-color: ${props => props.theme.background};
  color: ${props => props.theme.color};
  padding-top: ${props => props.theme.padding.top};
  padding-bottom: ${props => props.theme.padding.bottom};
  padding-left: ${props => props.theme.padding.left};
  padding-right: ${props => props.theme.padding.right};
  font-size: ${props => props.theme.fontSize};
  font-weight: ${props => props.theme.fontWeight};
  text-transform: ${props => props.theme.textTransform};
  display: flex;
  text-align: ${props => props.theme.align};
  justify-content: ${props => props.theme.align};
  font-family: ${variable.primaryFontFamily};
  cursor: pointer;
  border: 0;
  text-decoration: none;
  max-width: 28rem;
  min-width: ${props => props.theme.minWidth};
  border-radius: ${variable.radius};
  outline: none;
  transition: all 0.5s ease;

  &:focus {
    outline: none;
  }

  &:hover {
    background-color: ${variable.primary};
    color: ${variable.textColorLight};
    text-decoration: none;
  }

  ${props =>
    props.state === "disabled"
      ? `
        background-color:${variable.borderColor};

        &:hover {
            background-color:${variable.borderColor};
            color: ${props => props.theme.color};
            text-decoration: none;
        }
    `
      : null}: ${props =>
        props.width === "full"
          ? `
        display:flex;
        width:100%;
        max-width:100%;
    `
          : null};

  ${props =>
    props.align === "center"
      ? `
        align-self:center;
        margin:0 auto;
    `
      : null};

  ${props =>
    props.spacing && props.spacing.top
      ? `
        margin-top:${
      variable["spacing" + capitalizeFirstLetter(props.spacing.top)]
      };
    `
      : null};

  ${props =>
    props.spacing && props.spacing.bottom
      ? `
           margin-bottom:${
      variable["spacing" + capitalizeFirstLetter(props.spacing.bottom)]
      };
    `
      : null};
`;

const themes = {
  primary: {
    border: "transparent",
    color: `${variable.white}`,
    radius: `${variable.radius}`,
    fontSize: `${variable.textMedium}`,
    fontWeight: `${variable.bold}`,
    textTransform: "",
    background: `${variable.primary}`,
    align: "center",
    padding: {
      top: `${variable.spacingSmaller}`,
      right: `${variable.spacingLarge}`,
      bottom: `${variable.spacingSmaller}`,
      left: `${variable.spacingLarge}`
    }
  },
  secondary: {
    minWidth: "335px",
    border: "transparent",
    color: `${variable.white}`,
    radius: `${variable.radius}`,
    fontSize: `${variable.textMedium}`,
    fontWeight: `${variable.normal}`,
    textTransform: "",
    background: `${variable.primary}`,
    align: "center",
    padding: {
      top: `${variable.spacingSmallest}`,
      // right: `${variable.spacingSmallest}`,
      bottom: `${variable.spacingSmallest}`
      // left: `${variable.spacingSmallest}`
    }
  },
  secondaryAlt: {
    minWidth: "335px",
    border: `1px solid ${variable.primary}`,
    color: `${variable.primary}`,
    radius: `${variable.radius}`,
    fontSize: `${variable.textMedium}`,
    fontWeight: `${variable.normal}`,
    textTransform: "",
    background: `transparent`,
    align: "center",
    padding: {
      top: `${variable.spacingSmallest}`,
      // right: `${variable.spacingSmallest}`,
      bottom: `${variable.spacingSmallest}`
      // left: `${variable.spacingSmallest}`
    }
  }
};

/** @class Button
 *   relates to all base actions related to the @class Button
 *	Child components will exist within this component
 */
export default class Button extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      theme: themes["secondary"]
    };
  }

  componentDidMount = () => {
    let theme =
      typeof this.props.theme !== "undefined" ? this.props.theme : "secondary";
    this.setState({ theme: themes[theme] });
  };

  /** Render the component
   *	@param {props} returns the passed props of the class
   *	@param {state} returns the state of the class
   */
  render = props => {
    return (
      <Container
        onClick={!this.props.loading && !(this.props.state && this.props.state == "disabled") ? this.props.action : undefined}
        {...this.props}
        theme={this.state.theme}
        style={{
          backgroundColor: this.props.loading ? variable.primary : undefined,
          ...this.props.style
        }}
      >
        {this.props.preIcon &&
          <div
            style={{
              height: "45px",
              width: "51px",
              background: "#ffffff",
              marginTop: "-10px",
              marginBottom: "-10px",
              marginLeft: "-7px",
              marginRight: "-7px",
              lineHeight: "40px",
              borderRadius: "100px 0 0 100px",
              border: "solid 1px #eaeaf4",
              textAlign: "center",
            }}
          >
            <img
              style={{
                width: "20px",
                marginLeft: "4px",
              }}
              src={this.props.preIcon}
            />
          </div>
        }
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%"
          }}
        >
          <div>
            {(this.props.arrow || this.props.icon) && (
              <div style={{ width: 28 }} />
            )}
            {this.props.loading && (
              <img
                style={{ width: 22, marginLeft: 10, marginBottom: 2 }}
                src={WhiteSpinner}
              />
            )}
          </div>
          <div>{this.props.children}</div>
          <div>
            {this.props.loading && <div style={{ width: 28 }} />}
            {this.props.arrow && (
              <img
                style={{
                  height: 18,
                  resizeMode: "contain",
                  marginRight: 10,
                  marginBottom: 3
                }}
                src={RightArrow}
              />
            )}
            {this.props.icon &&
              // <img style={{ height: 18, resizeMode: 'contain', marginRight: 10, marginBottom: 3 }} src={this.props.icon} />
              this.props.icon}
          </div>
        </div>
      </Container>
    );
  };
}
